import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './ModelThresholds.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelState } from '../../reducers/initialState';
import ModelThresholdsListTable from './ModelThresholdsListTable';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { compareValues } from '../../utils';
import Form from 'react-bootstrap/Form';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';
import { getModelCategoryPermission } from '../../utils';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';
import ModelConfigurationContentTemplate from '../ModelTab/ModelConfigurationContentTemplate';
import Pagination from '../Pagination/Pagination';


const FLOW_SEQUENCE = 'FLOW_SEQUENCE';
const SENSOR = 'SENSOR';

const ModelThresholdsList = ({
  getModelThresholds,
  saveModelThreshold,
  describeModelThreshold,
  changeModelThreshold,
  setThresholdShowScreenStatus,
  flowSequences,
  modelComponentPositions,
  thresholds = { ...initialModelState.modelManager.selectedModel.Thresholds },
  intl,
  userProfileWidgets,
  userModelCategories,
  setCurrentPage,
}) => {
  let filter = thresholds.filter || '';
  let offset = thresholds.offset || 0;
  let limit = thresholds.limit || 1000;
  let initialLimit = 100;


  let { ModelCategoryId, ModelId } = useParams();

  const [currentEditId, setCurrentEditId] = useState(-1);
  const [currentFlowSequenceFilter, setCurrentFlowSequenceFilter] = useState(0);
  const [currentSensorFilter, setSurrentSensorFilter] = useState(0);
  const [active, setActive] = useState(false);
  const [thresholdId, setThresholdId] = useState(0);
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;




  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };


  const disableModeHandler = status => {
    setThresholdShowScreenStatus(status);
  };
  const searchHandler = (type, value) => {
    let filteredList = thresholds.ThresholdsList;


    if (type === FLOW_SEQUENCE) {
      if (value > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.SetpointId === value;
        });

      }
      if (currentSensorFilter > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.ModelComponentPositionId === currentSensorFilter;
        });

      }
    }

    if (type === SENSOR) {
      if (value > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.ModelComponentPositionId === value;
        });

      }
      if (currentFlowSequenceFilter > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.SetpointId === currentFlowSequenceFilter;
        });
      }
    }

  };

  const filterData = () => {
    let filteredList = thresholds.ThresholdsList;
    if (currentSensorFilter > 0) {
      filteredList = filteredList.filter(function (item) {
        return item.ModelComponentPositionId === currentSensorFilter;
      });
    }

    if (currentFlowSequenceFilter > 0) {
      filteredList = filteredList.filter(function (item) {
        return item.SetpointId === currentFlowSequenceFilter;
      });
    }

    return filteredList;
  };



  useEffect(() => {
    getModelThresholds(offset, limit, filter, ModelId, ModelCategoryId);
  }, [getModelThresholds, offset, limit, filter, ModelId, ModelCategoryId]);

  const setAddHandler = () => {
    changeModelThreshold({
      SelectedThreshold: {
        ...initialModelState.modelManager.selectedModel.Thresholds.SelectedThreshold,
        ModelId: ModelId,
        ModelCategoryId: ModelCategoryId
      }
    });
    setCurrentEditId(0);
    setThresholdShowScreenStatus(true);
  };

  const setEditHandler = modelThresholdId => {
    setCurrentEditId(modelThresholdId);
    if (modelThresholdId === -1) {
      changeModelThreshold({
        SelectedThreshold: {
          ...initialModelState.modelManager.selectedModel.Thresholds.SelectedThreshold,
          ModelId: ModelId
        }
      });
      setThresholdShowScreenStatus(false);
    } else {
      setThresholdShowScreenStatus(true);
    }
  };

  const flowSequenceOptions = () => {
    let flowSequenceData = [];
    const initData = {
      label: <FormattedMessage id="general.allSequences" defaultMessage="All Sequences" />,
      value: 0
    };
    flowSequenceData.push(initData);
    flowSequences.forEach(element => {
      flowSequenceData.push({
        label: element.Name,
        value: element.SetpointId
      });
    });

    return flowSequenceData.sort(compareValues('label'));
  };

  const modelComponentsOptions = () => {
    let modelComponentsData = [];
    const initData = {
      label: <FormattedMessage id="general.allComponents" defaultMessage="All Components" />,
      value: 0
    };
    modelComponentsData.push(initData);
    const sensorComponents = modelComponentPositions.filter(item => item.NeedFeedback === true);
    sensorComponents.forEach(element => {
      modelComponentsData.push({
        label: element.Name,
        value: element.ModelComponentPositionId
      });
    });

    return modelComponentsData.sort(compareValues('label'));
  };

  const onDropdownFilterFlowSequenceChange = e => {
    setCurrentFlowSequenceFilter(e.value);
    searchHandler(FLOW_SEQUENCE, e.value);
  };

  const onDropdownFilterSensorChange = e => {
    setSurrentSensorFilter(e.value);
    searchHandler(SENSOR, e.value);
  };

  const removeThresholdClick = thresholdId => {
    setActive(true);
    setThresholdId(thresholdId);
  };
  const DeleteThreshold = () => {
    let saveData = thresholds.SelectedThreshold;
    saveData.PerformDelete = true;
    saveData.ModelId = ModelId;
    saveData.ModelCategoryId = ModelCategoryId;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveData.ModelThresholdId = thresholdId;
    saveModelThreshold(saveData, 'MODELTHRESHOLDSDELETE');
  };

  const handleClose = () => {
    setActive(false);
    setThresholdId(0);
  };

  const handleConfirm = () => {
    DeleteThreshold();
    handleClose();
  };

  let messageId = (thresholds && thresholds.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELTHRESHOLDSEDIT');
  const isDeleteAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELTHRESHOLDSDELETE');
  const dialogTitle = intl.formatMessage({
    id: 'model.confirmDeleteThreshold',
    defaultMessage: 'Are you sure you want to delete the threshold?'
  });

  let isOwner = getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)
  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-list` },
    { label: <FormattedMessage id="model.manageModelThresholds" defaultMessage="Manage Model Thresholds" /> } // Last item has no href (current page)
  ];

  const dataObj = Object.values(filterData());
  return (
    <div className={s.modelThreshold}>
      {thresholds.isLoading && <LoadingSpinner />}
      {thresholds.showBanner && (
        <Banner failureText={messageText} showBanner={thresholds.showBanner} status={thresholds.isOpSuccessful} successText={messageText} />
      )}
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <ModelConfigurationContentTemplate selectedPage="manageModelThresholds" userProfileWidgets={userProfileWidgets} intl={intl}>
        <div className={s.contentWrapper}>
          <div className={s.componentHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="model.manageModelThresholds" defaultMessage="Manage Model Thresholds" />
              <span className={s.circle}>
                {thresholds.ThresholdsList.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.topAndSideOnlyRow}>
            <Col sm={12}>
              <Form.Label>
                <FormattedMessage id="common.filterBy" defaultMessage="Filter By" />
              </Form.Label>
            </Col>
          </Row>
          <Row className={s.topRow}>
            <Col sm={6} lg={4}>
              <Row>
                <Col sm={6}>
                  <Dropdown
                    id="filterFlowSequence"
                    dataArray={flowSequenceOptions()}
                    controlData={{
                      placeholderText: <FormattedMessage id="general.allSequences" defaultMessage="All Sequences" />,
                      customClassName: ''
                    }}
                    disabled={thresholds.showAddEditScreen}
                    onDropdownChange={onDropdownFilterFlowSequenceChange}
                    selectedOption={flowSequenceOptions().filter(option => option.value === currentFlowSequenceFilter)}
                    data-unittest="filterFlowSequence"
                  />
                </Col>
                <Col sm={6}>
                  <Dropdown
                    id="filtersensor"
                    dataArray={modelComponentsOptions()}
                    controlData={{
                      placeholderText: <FormattedMessage id="general.allComponents" defaultMessage="All Components" />,
                      customClassName: ''
                    }}
                    disabled={thresholds.showAddEditScreen}
                    onDropdownChange={e => onDropdownFilterSensorChange(e)}
                    selectedOption={modelComponentsOptions().filter(option => option.value === currentSensorFilter)}
                    data-unittest="filtersensor"
                  />
                </Col>
              </Row>
            </Col>
            <Col sm={6} lg={8}>
              {isOwner ? (
                <Button
                  className={s.addbutton}
                  style={WidgetVisibility(userProfileWidgets, 'MODELTHRESHOLDSADD')}
                  onClick={setAddHandler}
                  disabled={thresholds.showAddEditScreen}
                  data-unittest="addThresholdButton"
                >
                  + <FormattedMessage id="common.addNew" defaultMessage="ADD NEW" />
                </Button>
              ) : (
                ''
              )}
            </Col>
          </Row>

          <div>
            <Pagination
              data={dataObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={thresholds.currentPage}>
              <ModelThresholdsListTable
                setEditHandler={setEditHandler}
                selectedModelThresholdId={currentEditId}
                selectedModelCategoryId={ModelCategoryId}
                saveModelThreshold={saveModelThreshold}
                modelThreshold={thresholds}
                describeModelThreshold={describeModelThreshold}
                changeModelThreshold={changeModelThreshold}
                flowSequences={flowSequences}
                modelComponentPositions={modelComponentPositions}
                UpdateAllowed={isUpdateAllowed}
                DeleteAllowed={isDeleteAllowed}
                disableMode={thresholds.showAddEditScreen}
                disableModeHandler={disableModeHandler}
                removeThreshold={removeThresholdClick}
                isOwner={isOwner}
              />
            </Pagination>
          </div>

        </div>
      </ModelConfigurationContentTemplate>
    </div>
  );
};

ModelThresholdsList.propTypes = {
  describeModelThreshold: PropTypes.func.isRequired
};

export default injectIntl(ModelThresholdsList);
